import React from 'react'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { TextField, Button } from '@mui/material';

import { useDispatch } from 'react-redux';
import { setMode } from '../features/darkmode';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useSelector } from 'react-redux';

export default function SetTheme(props) {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {/* <Typography id="modal-modal-title" variant="h6" component="h2">
          Seleziona il tema da utilizzare
        </Typography> */}
        <RadioTheme />
      </Box>
    </Modal>
  )
}

function RadioTheme() {

  const theme = useSelector(state => state.darkmode.mode)
  const [value, setValue] = React.useState(theme)
  const dispatch = useDispatch()

  const handleRadioChange = (event) => {
    setValue(event.target.value)
    dispatch(setMode(event.target.value))
  }

  return (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">Seleziona il tema da utilizzare</FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        value={value}
        onChange={handleRadioChange}
      >
        <FormControlLabel value="dark" control={<Radio />} label="Scuro" />
        <FormControlLabel value="light" control={<Radio />} label="Chiaro" />
        <FormControlLabel value="system" control={<Radio />} label="predefinito di sistema" />
      </RadioGroup>
    </FormControl>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight:'90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px'
};

// const mapLangToSystem = {
  
// }